export default {
  order_status_toast: {
    order_reviewed: '#{{number}} Tilauksesi on nähty',
    order_confirmed: '#{{number}} Vahvistettu aika {{time}}',
    order_preparation_up_time_changed: '#{{number}} {{type}}-aika muuttui ajaksi {{time}}',
    serving_time_changed: '#{{number}} Tilauksesi tarjoillaan klo {{time}}',
    order_preparing: 'Tilauksesi #{{number}} on valmistumassa',
    order_rejected: '#{{number}} tilaus hylätty',
  },
  order_type: {
    pickup: 'Nouto',
    delivery: 'Toimitus',
  },
};
